import request from '@/utils/request';

// 同步日志列表
export function getSyncLogList(query) {
  return request({
    url: '/sync-log/list',
    method: 'get',
    params: query
  });
}

// 同步日志详情
export function getSyncLogDetail(id) {
  return request({
    url: "/sync-log/".concat(id),
    method: 'get'
  });
}

// 手动触发同步
export function triggerSync(syncType) {
  return request({
    url: '/sync-log/trigger',
    method: 'post',
    data: {
      syncType: syncType
    }
  });
}

// 全量同步
export function fullSync() {
  return request({
    url: '/sync-log/full-sync',
    method: 'post'
  });
}

// 获取同步统计
export function getSyncStatistics() {
  return request({
    url: '/sync-log/statistics',
    method: 'get'
  });
}